import MediaCard from 'components/cards/new/common/MediaCard'
import Button from 'components/forms/Button'
import Link from 'next/link'

const HowWeWorkWithW4B = () => {
  return (
    <MediaCard
      image={{
        alt: 'Robot pointing at WhatsApp chat on a phone',
        desktop: {
          dimensions: {
            height: 580,
            width: 480,
          },
          src: '/images/new/whatsapp/robot-pointing-wa-chat.png',
        },
        mobile: {
          dimensions: {
            height: 580,
            width: 480,
          },
          src: '/images/new/whatsapp/robot-pointing-wa-chat.png',
        },
      }}
      layout={{
        desktop: 'content-right-media-left',
        mobile: 'content-top-media-bottom',
      }}
      imageFitPreset='contain-center'
      imageContainerWidth='43%'
    >
      <div className='d-flex flex-column flex-1 px-4 pt-8 pt-lg-13 pb-lg-10 pe-lg-10'>
        <h2 className='fs-fluid-36-48 lh-105 fw-semibold mb-lg-5 mb-2'>
          How we work with
          <br className='d-none d-lg-block' /> WhatsApp Business.
        </h2>
        <p className='fs-fluid-18-24 fw-semibold lh-132 mb-2'>
          We are an independent provider of world-class{' '}
          <strong>virtual office products and solutions</strong>, used by{' '}
          <strong>over 100,000 customers</strong> to date. The product and
          service we offer is access to a unique and personalised business
          number, so that you can connect with WhatsApp Business. All enquiries
          relating to the WhatsApp business account should be directed towards
          WhatsApp.
        </p>

        <p className='fs-fluid-18-24 fw-semibold lh-132 mb-0'>
          For all of your WhatsApp Business number enquiries, please contact us
          via our Service Desk.
        </p>
        <Link
          href='/contact-us'
          className='mt-10 align-self-lg-end d-none d-lg-block'
        >
          <Button className='w-auto '>Contact Us</Button>
        </Link>
      </div>
    </MediaCard>
  )
}

export default HowWeWorkWithW4B
